export enum BoxVariant {
    AppBoxed = 'appBoxed',
    ContentBoxed = 'contentBoxed',
    UnBoxed = 'unBoxed',
}
